function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import tasks from '@/js/tasks';
import { ROLES_LIST, DATAPLEX_STATES } from '@/js/constants';
import DialogsComponent from '@/components/DialogsComponent.vue';
import project_service from '@/apps/chatbots/services/projects_services';
import channels_services from '@/apps/chatbots/services/channels_services';
export default {
  data: function data() {
    return {
      DATAPLEX_STATES: DATAPLEX_STATES,
      tab: 0,
      edit: false,
      view: false,
      filters: {},
      show_detail: false,
      filter_enabled: true,
      collapse_filter: false,
      item_selected: {},
      data: [],
      data_to_filter: [],
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      permissions: [],
      pagination_permissions: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      headers_permissions: [{
        value: 'email',
        text: 'Usuario'
      }, {
        value: 'owner',
        text: 'Propietario'
      }, {
        value: 'view_permission',
        text: 'Ver'
      }, {
        value: 'edit_permission',
        text: 'Editar'
      }, {
        value: 'delete_permission',
        text: 'Eliminar'
      }, {
        value: 'actions',
        text: 'Acciones'
      }],
      headers_executions: [{
        value: 'uid',
        text: 'UID'
      }, {
        value: 'state',
        text: 'Estado'
      }, {
        value: 'startTime',
        text: 'Fecha Inicio'
      }, {
        value: 'endTime',
        text: 'Fecha Fin'
      }, {
        value: 'actions',
        text: 'Acciones'
      }],
      connections: [],
      alcances: [{
        text: 'Datos Completos',
        value: 'FULL'
      }, {
        text: 'Incremental',
        value: 'INCREMENTAL'
      }],
      rules: {
        display_name: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 256 || 'Menor o igual a 256 caracteres.';
        }],
        description: [function (v) {
          return v === '' || v === undefined || v == null || v && v.length <= 1024 || 'Menor o igual a 1024 caracteres.';
        }],
        data_scan_id: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 63 || 'Menor o igual a 63 caracteres.';
        }, function (v) {
          return /^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$/.test(v) || 'Solo minúsculas, empieza con una letra, puede contener letras, numero o guiones, debe terminar con una letra o número.';
        }],
        table_input: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return /^[a-z][a-z0-9-]*[a-z0-9].[A-Za-z_][A-Za-z0-9_]{0,1023}\.[A-Za-z_][A-Za-z0-9_]{0,1023}$/.test(v) || 'Formato Incorrecto {project.dataset.table}';
        }],
        table_output: [function (v) {
          return v === '' || v === undefined || v == null || /^[a-z][a-z0-9-]*[a-z0-9].[A-Za-z_][A-Za-z0-9_]{0,1023}\.[A-Za-z_][A-Za-z0-9_]{0,1023}$/.test(v) || 'Formato Incorrecto {project.dataset.table}';
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc', 'has_dataplex_active'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    headers: function headers() {
      return [{
        value: 'name',
        text: this.traductor('chatbots.channels.name')
      }, {
        value: 'description',
        text: this.traductor('chatbots.channels.description')
      }, {
        value: 'type',
        text: this.traductor('chatbots.channels.type')
      }, {
        value: 'domain',
        text: 'Domain'
      }, {
        value: 'actions',
        text: this.traductor('chatbots.projects.actions')
      }];
    }
  }),
  created: function created() {
    this.listChannels();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    formatDate: function formatDate(data) {
      if (data) {
        return data ? data.substring(0, 19).replace('T', ' ') : '';
      }
      return '';
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onSearch: function onSearch() {
      var _this = this;
      this.data = Object.assign([], this.data_to_filter);
      if (this.filters.name) {
        this.data = this.data.filter(function (x) {
          return x.name.toUpperCase().indexOf(_this.filters.name.toUpperCase()) !== -1;
        });
      }
      if (this.filters.description) {
        this.data = this.data.filter(function (x) {
          return x.description.toUpperCase().indexOf(_this.filters.description.toUpperCase()) !== -1;
        });
      }
    },
    onLimpiar: function onLimpiar() {
      this.data = Object.assign([], this.data_to_filter);
      this.resetFilters();
    },
    resetFilters: function resetFilters() {
      this.filters = {};
      this.listChannels();
    },
    getConnectionName: function getConnectionName(id) {
      var item = this.connections.find(function (x) {
        return x.id === id;
      });
      if (item) {
        return item.name;
      }
      return '';
    },
    listChannels: function listChannels() {
      var _this2 = this;
      channels_services.getAll().then(function (response) {
        console.log(response);
        if (response.success) {
          _this2.data = response.data;
          _this2.data_to_filter = Object.assign([], _this2.data);
          _this2.pagination.total = response.data.length;
        }
      });
    },
    goCreatePage: function goCreatePage() {
      this.$router.push({
        name: 'ChannelManagementCreate'
      });
    },
    onEditChannel: function onEditChannel(item) {
      this.$router.push({
        name: 'ChannelManagementUpdate',
        params: {
          id: item.id
        }
      });
    },
    onViewChannel: function onViewChannel(item) {
      this.$router.push({
        name: 'ChannelManagementView',
        params: {
          id: item.id
        }
      });
    },
    onRemoveChannel: function onRemoveChannel(item) {
      this.item_selected = Object.assign({}, item);
      this.$refs['DIALOG_REMOVE_PROJECT'].onOpen();
    },
    onEditPermission: function onEditPermission(item) {
      this.item_selected = Object.assign({}, item);
      this.$refs['DIALOG_PERMISSIONS_PROJECT'].onOpen();
      this.listPermissions();
    },
    listPermissions: function listPermissions() {
      var _this3 = this;
      project_service.getPermissions(this.item_selected.id).then(function (response) {
        _this3.permissions = [];
        response.data.forEach(function (item) {
          var obj = Object.assign({}, item);
          obj.email = '' + obj.id;
          delete obj.id;
          _this3.permissions.push(obj);
        });
      });
    },
    addRowPermission: function addRowPermission() {
      this.permissions.unshift({
        new: true
      });
    },
    addPermissions: function addPermissions(permission) {
      var _this4 = this;
      if (!this.$refs.form_permission.validate()) {
        return;
      }
      var data = {
        id: permission.email,
        edit_permission: permission.edit_permission,
        delete_permission: permission.delete_permission
      };
      project_service.addPermissions(this.item_selected.id, data).then(function (response) {
        if (response.success) {
          tasks.toast.success('Permiso agregado correctamente.');
          _this4.listPermissions();
        } else {
          tasks.toast.error('No se pudo agregar el permiso.');
        }
      });
    },
    updatePermissions: function updatePermissions(permission) {
      var _this5 = this;
      var data = {
        id: permission.email,
        edit_permission: permission.edit_permission,
        delete_permission: permission.delete_permission
      };
      project_service.updatePermissions(this.item_selected.id, data).then(function (response) {
        if (response.success) {
          tasks.toast.success('Permiso modificado correctamente.');
          _this5.listPermissions();
        } else {
          tasks.toast.error('No se pudo guardar el permiso.');
        }
      });
    },
    deletePermissions: function deletePermissions(permission) {
      var _this6 = this;
      var data = {
        id: permission.email
      };
      project_service.deletePermissions(this.item_selected.id, data).then(function (response) {
        if (response.success) {
          tasks.toast.success('Permiso eliminado correctamente.');
          _this6.listPermissions();
        } else {
          tasks.toast.error('No se pudo eliminar el permiso.');
        }
      });
    },
    onConfirmRemoveChannel: function onConfirmRemoveChannel(value) {
      var _this7 = this;
      if (value) {
        channels_services.delete(this.item_selected.id).then(function (response) {
          if (response.success) {
            tasks.toast.success('Se ha eliminado correctamente el registro.');
            _this7.$refs['DIALOG_REMOVE_PROJECT'].onClose();
            _this7.onLimpiar();
          } else {
            if (response.message) {
              tasks.toast.warning(response.message);
            } else {
              tasks.toast.error("No se pudo eliminar el registro.");
            }
            _this7.$refs["DIALOG_REMOVE_PROJECT"].onClose();
          }
        });
      } else {
        this.$refs['DIALOG_REMOVE_PROJECT'].onClose();
      }
    }
  }
};